import {useDispatch, useSelector} from 'react-redux';
import {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {getCurrentUser, setCurrentUser} from "../../store/reducers/user/user.reducer";
import toast from "react-hot-toast";
import sendApiRequest, {NetworkMethods} from "../../lib/Network";

export default function SignOut() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const currentUser = useSelector(getCurrentUser);

    useEffect(() => {
        sendRequest();

        return () => {};
    }, []);

    const sendRequest = async () => {
        try {

            const response = await sendApiRequest({
                method: NetworkMethods.POST,
                endpoint: 'user/sign-out',
                headers: {
                    "x-public-key": process.env.REACT_APP_PUBLIC_REQUEST_KEY,
                },
                payload: {
                    token: currentUser.token
                },
            });

            if (!response.isSuccess) {
                toast.error("Hiba a kijelentkezés során :(");
                return;
            }

            toast.success("Sikeres kijelentkezés!");
            setCurrentUser(null);
            navigate("/bejelentkezes");
        } catch (error) {
            toast.error("Hiba a kijelentkezés során :(");
        }
    }

    return <h6>Sikeres kijelentkezés!</h6>
}